import { createReducer, on } from '@ngrx/store';
import * as NotificationMessagesActions from './notification-messages.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import {
  ExcludableList,
  INotificationMessage,
  MessageEventType,
} from '@boma/shared/entities';
import { sortBy } from 'lodash';

export const notificationMessagesFeatureKey = 'notificationMessages';

export interface NotificationMessagesState
  extends EntityState<INotificationMessage> {
  page: number;
  pageSize: number;
  nextPage?: number;
  messageEventTypes: ExcludableList<MessageEventType>;
  addingMessageEvents: boolean;
  loadingLatest: boolean;
}

export const notificationsAdapter: EntityAdapter<INotificationMessage> = createEntityAdapter<
  INotificationMessage
>({ selectId: (model) => model.id });
export const notificationMessagesInitialState: NotificationMessagesState = notificationsAdapter.getInitialState(
  {
    page: 1,
    pageSize: 25,
    nextPage: 2,
    messageEventTypes: new ExcludableList<MessageEventType>(),
    addingMessageEvents: false,
    loadingLatest: false,
  }
);

export interface NotificationMessagesPartialState {
  readonly [notificationMessagesFeatureKey]: NotificationMessagesState;
}

export const notificationMessagesReducer = createReducer(
  notificationMessagesInitialState,
  on(NotificationMessagesActions.loadNotificationMessages, (state) => state),
  on(
    NotificationMessagesActions.loadNotificationMessagesSuccess,
    (state, action) => {
      // console.log(action);
      if (action.refresh)
        return notificationsAdapter.setAll(action.data.items, {
          ...state,
          nextPage: action.data.nextPage,
        });
      else
        return notificationsAdapter.upsertMany(action.data.items, {
          ...state,
          nextPage: action.data.nextPage,
        });
    }
  ),
  on(
    NotificationMessagesActions.loadNotificationMessagesFailure,
    (state, action) => state
  ),
  on(
    NotificationMessagesActions.addNotificationMessagesEvents,
    (state, action) => ({ ...state, addingMessageEvents: true })
  ),
  on(
    NotificationMessagesActions.addNotificationMessagesEventsSuccess,
    (state, action) =>
      notificationsAdapter.upsertMany(action.payload, {
        ...state,
        addingMessageEvents: false,
      })
  ),
  on(
    NotificationMessagesActions.addNotificationMessagesEventsFailure,
    (state, action) => ({ ...state, addingMessageEvents: false })
  ),
  on(NotificationMessagesActions.loadLatestMessages, (state, action) => ({
    ...state,
    loadingLatest: true,
  })),
  on(NotificationMessagesActions.loadLatestMessagesSuccess, (state, action) => {
    const updated = sortBy(
      [
        ...action.data.items,
        ...notificationsAdapter.getSelectors().selectAll(state),
      ],
      (value) => value.createdAt
    ).reverse();
    console.log('Updated', updated);
    return notificationsAdapter.setAll(updated, {
      ...state,
      loadingLatest: false,
    });
  }),
  on(NotificationMessagesActions.loadLatestMessagesFailure, (state, _) => ({
    ...state,
    loadingLatest: false,
  }))
);
